namespace $.$$ {
	export class $mol_string_demo extends $.$mol_string_demo {
		
		broken( next?: string ) {
			return $mol_fail( new Error( 'Demo error' ) )
		}
		
	}
}
